import {
ACTION_EDITSTAFFAUTHORIZATIONGROUP_SUCCESS,
ACTION_STAFFAUTHORIZATIONGROUPDETAIL_SUCCESS
} from './action';
import createReducer from '../../../../reducers/createReducer';

const INITIAL_STATE = {
        data: [],
        loading: false
    };

const EditStaffAuthorizationGroupReducer = createReducer(
	INITIAL_STATE,
	{
		[ACTION_EDITSTAFFAUTHORIZATIONGROUP_SUCCESS](state, action) {
            return Object.assign({}, {
                ...state,
                data: action.payload.data,
                tag: ACTION_EDITSTAFFAUTHORIZATIONGROUP_SUCCESS,
                loading: false
            });
        },
        [ACTION_STAFFAUTHORIZATIONGROUPDETAIL_SUCCESS](state, action) {
            return Object.assign({}, {
                ...state,
                data: action.payload.data,
                tag: ACTION_STAFFAUTHORIZATIONGROUPDETAIL_SUCCESS,
                loading: false
            });
        }
	}
);
export default EditStaffAuthorizationGroupReducer;